var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPerfomance(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "700pt",
    height: "700pt",
    viewBox: "150 150 400 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m203 364h73.078l-1.0508 3.2891 21 15.051 7.9102 24.289h0.35156l-25.688 75.531 32.48-8.8203 21 26.602 18.621-55.512 19.531 55.441 20.16-26.879 32.621 8.2617-26.816-75.254 7.7695-23.871 21-15.051-1.3984-3.0781h73.43c9.2812 0 18.184-3.6875 24.75-10.25 6.5625-6.5664 10.25-15.469 10.25-24.75v-189c0-9.2812-3.6875-18.184-10.25-24.75-6.5664-6.5625-15.469-10.25-24.75-10.25h-294c-9.2812 0-18.184 3.6875-24.75 10.25-6.5625 6.5664-10.25 15.469-10.25 24.75v189c0 9.2812 3.6875 18.184 10.25 24.75 6.5664 6.5625 15.469 10.25 24.75 10.25zm-21-35v-6.3008c6.7266 1.3711 12.902 4.6914 17.754 9.5469 4.8555 4.8516 8.1758 11.027 9.5469 17.754h-6.3008c-5.5703 0-10.91-2.2109-14.848-6.1523-3.9414-3.9375-6.1523-9.2773-6.1523-14.848zm144.76 141.68-10.289-13.301-16.242 4.6211 18.48-55.16h10.289l10.57 7.6289 3.4297 8.4727zm57.68-13.578-10.078 13.441-18.691-53.129 14.84-10.781 10.988-0.003906 19.25 54.602zm23.801-95.129-16.242 11.688-6.1602 18.969h-19.879l-15.961 11.691-16.172-11.691h-20.02l-5.8086-18.969-16.172-11.691 5.8125-18.969-6.1602-18.969 16.52-11.691 6.1602-18.969h19.879l15.961-11.691 16.102 11.691h19.949l5.9492 18.969 16.172 11.691-6.0938 18.969zm8.5391-18.973 7.9102-24.289-21-15.051-7.9102-24.289h-25.27l-21-15.051-21 15.051h-24.922l-7.9102 24.289-21 15.051 8.2617 24.289-2.3086 7h-57.191c-1.5195-10.449-6.375-20.129-13.844-27.598s-17.148-12.324-27.598-13.844v-148.12c10.449-1.5195 20.129-6.375 27.598-13.844s12.324-17.148 13.844-27.598h253.12c1.5195 10.449 6.375 20.129 13.844 27.598s17.148 12.324 27.598 13.844v148.12c-10.449 1.5195-20.129 6.375-27.598 13.844s-12.324 17.148-13.844 27.598h-57.539zm80.219 7h-6.3008c1.3711-6.7266 4.6914-12.902 9.5469-17.754 4.8516-4.8555 11.027-8.1758 17.754-9.5469v6.3008c0 5.5703-2.2109 10.91-6.1523 14.848-3.9375 3.9414-9.2773 6.1523-14.848 6.1523zm21-210v6.3008c-6.7266-1.3711-12.902-4.6914-17.754-9.5469-4.8555-4.8516-8.1758-11.027-9.5469-17.754h6.3008c5.5703 0 10.91 2.2109 14.848 6.1523 3.9414 3.9375 6.1523 9.2773 6.1523 14.848zm-315-21h6.3008c-1.3711 6.7266-4.6914 12.902-9.5469 17.754-4.8516 4.8555-11.027 8.1758-17.754 9.5469v-6.3008c0-5.5703 2.2109-10.91 6.1523-14.848 3.9375-3.9414 9.2773-6.1523 14.848-6.1523z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m427 133h-154v56h154zm-14 42h-126v-28h126z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m350 301c-11.141 0-21.82 4.4258-29.699 12.301-7.875 7.8789-12.301 18.559-12.301 29.699s4.4258 21.82 12.301 29.699c7.8789 7.875 18.559 12.301 29.699 12.301s21.82-4.4258 29.699-12.301c7.875-7.8789 12.301-18.559 12.301-29.699s-4.4258-21.82-12.301-29.699c-7.8789-7.875-18.559-12.301-29.699-12.301zm0 70c-7.4258 0-14.547-2.9492-19.801-8.1992-5.25-5.2539-8.1992-12.375-8.1992-19.801s2.9492-14.547 8.1992-19.801c5.2539-5.25 12.375-8.1992 19.801-8.1992s14.547 2.9492 19.801 8.1992c5.25 5.2539 8.1992 12.375 8.1992 19.801s-2.9492 14.547-8.1992 19.801c-5.2539 5.25-12.375 8.1992-19.801 8.1992z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m252 231h196v14h-196z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m252 203h56v14h-56z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m392 203h56v14h-56z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m238 259h-14v14h-14v14h14v14h14v-14h14v-14h-14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m476 301v-14h14v-14h-14v-14h-14v14h-14v14h14v14z"
  }), /*#__PURE__*/React.createElement("use", {
    x: 70,
    y: 665,
    xlinkHref: "#u"
  }), /*#__PURE__*/React.createElement("use", {
    x: 95.6875,
    y: 665,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 112.945312,
    y: 665,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 136.683594,
    y: 665,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    x: 160.304688,
    y: 665,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 177.035156,
    y: 665,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 200.773438,
    y: 665,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("use", {
    x: 238.011719,
    y: 665,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("use", {
    x: 263.0625,
    y: 665,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("use", {
    x: 298.0625,
    y: 665,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    x: 336.671875,
    y: 665,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 360.40625,
    y: 665,
    xlinkHref: "#t"
  }), /*#__PURE__*/React.createElement("use", {
    x: 372.40625,
    y: 665,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.136719,
    y: 665,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 412.875,
    y: 665,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    x: 437.789062,
    y: 665,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 455.050781,
    y: 665,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    x: 478.667969,
    y: 665,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("use", {
    x: 499.5,
    y: 665,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 523.238281,
    y: 665,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 70,
    y: 700,
    xlinkHref: "#r"
  }), /*#__PURE__*/React.createElement("use", {
    x: 85.226562,
    y: 700,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 102.488281,
    y: 700,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 126.53125,
    y: 700,
    xlinkHref: "#q"
  }), /*#__PURE__*/React.createElement("use", {
    x: 175.1875,
    y: 700,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 191.917969,
    y: 700,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 216.835938,
    y: 700,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 252.757812,
    y: 700,
    xlinkHref: "#o"
  }), /*#__PURE__*/React.createElement("use", {
    x: 282.050781,
    y: 700,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 306.097656,
    y: 700,
    xlinkHref: "#n"
  }), /*#__PURE__*/React.createElement("use", {
    x: 331.011719,
    y: 700,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    x: 368.117188,
    y: 700,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("use", {
    x: 393.765625,
    y: 700,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.027344,
    y: 700,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 435.074219,
    y: 700,
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("use", {
    x: 447.070312,
    y: 700,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 470.808594,
    y: 700,
    xlinkHref: "#k"
  }), /*#__PURE__*/React.createElement("use", {
    x: 491.554687,
    y: 700,
    xlinkHref: "#c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPerfomance);
export default __webpack_public_path__ + "static/media/icon-perfomance.2c67c18c.svg";
export { ForwardRef as ReactComponent };